import { render, staticRenderFns } from "./UserMenuVX.vue?vue&type=template&id=7f77ebe7"
import script from "./UserMenuVX.vue?vue&type=script&lang=js"
export * from "./UserMenuVX.vue?vue&type=script&lang=js"
import style0 from "./UserMenuVX.vue?vue&type=style&index=0&id=7f77ebe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports